import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import TextArea from 'components/controls/TextArea';
import DropdownList from 'components/controls/DropdownList';
import _validator from 'modules/validator';
import AadhaarAvatar from 'components/controls/uploadAadhaar';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import { Radio, DatePicker, Icon } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import InputCheck from 'components/controls/InputCheck';
import _notification from 'modules/notification';
import moment from 'moment';
import NavigationTab from './NavigationTab_new_one';
import States from '../../constants/States.json';
import ScribePdfModalViwer from './modalForPdf';
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// replaces this page's 4 top-level `.candidateform-cover` sections — see
// frontendDesign/Stage_3_5/Implementation/ERPM_S3_5_Component_Usage.md. The 2 NESTED
// `.candidateform-cover` divs inside the PwBD section (ScribePdfModalViwer, Disability Certificate
// upload) are left as plain divs, unchanged — they're sub-panels within that Card, not separate
// top-level sections, and nesting Card-in-Card would double up padding/shadow visually.
import Card from 'components/enterprise/Card';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 (Enterprise Candidate Experience Final UI Polish & UX Optimization): validation messages
// are set via setState with a plain string, so they use the plain resolveText() helper — see
// NewLogin.jsx's identical comment for why (class component methods run outside React's render cycle
// and can't call the useLanguage() hook).
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class CandidatePersonalInfo_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            posts: [],
            CategoriesList: [],
            selectedCategory: "",
            //setScribeImageImagePath: "",

            isLoading: false,

            appliedForError: '',
            firstNameError: '',
            middleNameError: '',
            lastNameError: '',
            motherNameError: '',
            fatherNameError: '',
            dobError: '',
            mobileError: '',
            emailError: '',
            drivingLicenceError: '',
            addressError: '',
            villageError: '',
            talukaError: '',
            stateError: '',
            districtError: '',
            pinError: '',
            genderError: '',
            maritalStatusError: '',

            isSectionEnabled: false,
            hasInteracted: false,
            selectedDisability: null,
            //dependentCheckboxes: {}, 


            selectedCategory: '',
            categoryError: '',
            dependentCheckboxes: {},
            setScribeImageImagePath: '',
            ScribeImagePath: "",


            confirmCheck: false,
            confirmError: '',


            //  showModal: false,
        };
    }

    componentDidMount() {
        this.getStudentPersonalData();
        this.getAllPost();
        this.getAllDisableCategories();
    }



    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _StudentService.getStudentPersonalInfo();
                    //console.log("Candidate Data: ", response.data);
                    this.setState({
                        data: response.data,
                        loading: false,
                        isSectionEnabled: response.data.Is_Handicaped,

                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllPost = async () => {
        try {
            this.setState({ isLoading: true }, async () => {
                try {
                    let response = await _StudentService.getAllPosts();
                    //console.log("Post Data: ", response.data);
                    this.setState({ posts: response.data, isLoading: false });

                } catch (e) {
                    // TODO
                    this.setState({ isLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    updateStudentPersonalData = async () => {
        try {

            if (this.validate()) {
                return
            }

            this.setState({
                isLoading: true
            }, async () => {
                try {
                    let body = { ...this.state.data };
                    //console.log("Final Body: ", body);

                    const response = await _StudentService.updateStudentPersonalData(body);
                    //console.log(response);
                    if (response.data.IsSuccess) {
                        this.setState({
                            isLoading: false
                        }, () => {
                            _notification.showMessage('success', 'Personal information saved successfully.');
                            this.onTabOrderChange();
                            //this.props.history.push({pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId }})
                        })
                    }
                    else {
                        this.setState({
                            isLoading: false
                        }, () => {
                            _notification.showMessage('error', response.data.Message ? response.data.Message : response.data.Obj.ListOfCompulsouryFields.join(' '));
                        })
                    }
                } catch (e) {
                    // TODO
                    this.setState({
                        isLoading: false
                    });
                    console.log('Error: ', e);
                }
            });

        } catch (e) { }
    }

    validate = () => {
        let body = { ...this.state.data };
        //console.log("final body: ", body);

        this.setState({
            appliedForError: '',
            firstNameError: '',
            middleNameError: '',
            lastNameError: '',
            motherNameError: '',
            fatherNameError: '',
            dobError: '',
            mobileError: '',
            emailError: '',
            drivingLicenceError: '',
            addressError: '',
            villageError: '',
            talukaError: '',
            stateError: '',
            districtError: '',
            pinError: '',
            genderError: '',
            maritalStatusError: ''
        });

        let hasError = false;

        if (body.Birth_Date == '0001-01-01T00:00:00') {
            this.setState({
                data: {
                    ...this.state.data,
                    "Birth_Date": moment(),
                },
            });
        }

        if (!body.Applied_Post) {
            this.setState({ appliedForError: tr('personalInfo.appliedForError') });
            hasError = true
        }

        if (!body.First_Name || !body.First_Name.trim()) {
            this.setState({ firstNameError: tr('personalInfo.firstNameRequiredError') });
            hasError = true
        }

        if (!body.Middle_Name || !body.Middle_Name.trim()) {
            this.setState({ middleNameError: tr('personalInfo.middleNameRequiredError') });
            hasError = true
        }

        if (!body.Last_Name || !body.Last_Name.trim()) {
            this.setState({ lastNameError: tr('personalInfo.lastNameRequiredError') });
            hasError = true
        }

        if (!body.Mother_Name || !body.Mother_Name.trim()) {
            this.setState({ motherNameError: tr('personalInfo.motherNameRequiredError') });
            hasError = true
        }

        if (!body.Father_Name || !body.Father_Name.trim()) {
            this.setState({ fatherNameError: tr('personalInfo.fatherNameRequiredError') });
            hasError = true
        }

        if (!body.Birth_Date) {
            this.setState({ dobError: tr('personalInfo.dobRequiredError') });
            hasError = true
        }

        if (!body.Gender) {
            this.setState({ genderError: tr('personalInfo.genderRequiredError') });
            hasError = true
        }

        if (!body.Marital_Status) {
            this.setState({ maritalStatusError: tr('personalInfo.maritalStatusRequiredError') });
            hasError = true
        }

        // if (!body.Mobile_Number || !body.Mobile_Number.trim()) {
        //     this.setState({ mobileError: 'Please Enter Mobile number' });
        //     hasError = true
        // }

        if (!body.Mobile_Number || !body.Mobile_Number.trim()) {
            this.setState({ mobileError: tr('personalInfo.mobileRequiredError') });
            hasError = true;
        } else if (body.Mobile_Number && body.Mobile_Number.trim().length !== 10 || !/^\d{10}$/.test(body.Mobile_Number.trim())) {
            this.setState({ mobileError: tr('personalInfo.mobileInvalidError') });
            hasError = true;
        }

        if (!body.Email || !body.Email.trim()) {
            this.setState({ emailError: tr('personalInfo.emailRequiredError') });
            hasError = true
        }

        if (!_validator.verifyEmail(body.Email)) {
            this.setState({ emailError: tr('personalInfo.emailInvalidError') });
            hasError = true
        }

        if (body.IsDrivingLicenceMandatory)
            if (!body.DrivingLicenceNumber || !body.DrivingLicenceNumber.trim()) {
                this.setState({ drivingLicenceError: tr('personalInfo.drivingLicenceRequiredError') });
                hasError = true
            }

        if (!body.Address || !body.Address.trim()) {
            this.setState({ addressError: tr('personalInfo.addressRequiredError') });
            hasError = true
        }

        if (!body.Village || !body.Village.trim()) {
            this.setState({ villageError: tr('personalInfo.villageRequiredError') });
            hasError = true
        }

        if (!body.Taluka || !body.Taluka.trim()) {
            this.setState({ talukaError: tr('personalInfo.talukaRequiredError') });
            hasError = true
        }

        if (!body.State || !body.State.trim()) {
            this.setState({ stateError: tr('personalInfo.stateRequiredError') });
            hasError = true
        }

        if (!body.District || !body.District.trim()) {
            this.setState({ districtError: tr('personalInfo.districtRequiredError') });
            hasError = true
        }

        if (!body.Pin_Code || !body.Pin_Code.trim()) {
            this.setState({ pinError: tr('personalInfo.pinRequiredError') });
            hasError = true
        }
        return hasError;
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(1);
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onDateChange = (date, dateString) => {
        this.setState({
            data: {
                ...this.state.data,
                Birth_Date: date ? date.format("YYYY-MM-DDT00:00:00") : ""
                //Birth_Date: date.format("YYYY-MM-DDT00:00:00"),
            },
        });
    };

    onTextChange = (event) => {

        if ((event.target.name == 'Mobile_Number'
            || event.target.name == 'Pin_Code')
            // || event.target.name == 'Phone_Number'
            && !_validator.isDigit(event.target.value))
            return;

        if (event.target.name == 'Mobile_Number' && event.target.value.length > 10)
            return;

        // if (event.target.name == 'Phone_Number' && event.target.value.length > 11)
        //     return;

        if ((event.target.name == 'First_Name'
            || event.target.name == 'Middle_Name'
            || event.target.name == 'Last_Name'
            || event.target.name == 'Mother_Name'
            || event.target.name == 'Father_Name') && !_validator.onlyAlphabets(event.target.value))
            return;

        if ((event.target.name == 'First_Name'
            || event.target.name == 'Middle_Name'
            || event.target.name == 'Last_Name'
            || event.target.name == 'Mother_Name'
            || event.target.name == 'Father_Name') && event.target.value.length > 20)
            return;

        if (event.target.name == 'Email' && event.target.value.length > 50)
            return;

        if (event.target.name == 'DrivingLicenceNumber' && event.target.value.length > 20)
            return;

        if ((event.target.name == 'Village'
            || event.target.name == 'District'
            || event.target.name == 'Taluka') && event.target.value.length > 20)
            return;

        if (event.target.name == 'Address' && event.target.value.length > 200)
            return;

        if (event.target.name == 'Pin_Code' && event.target.value.length > 6)
            return;

        this.setState({
            data: {
                ...this.state.data,
                [event.target.name]: event.target.value,
            },
        });
    }

    onPostChange = (event) => {
        //console.log(event.target.name, " ", event.target.value);
        //let temp = this.state.posts.find((item) => item.Id == event.target.value);
        this.setState({
            data: {
                ...this.state.data,
                [event.target.name]: event.target.value,
                //['Applied_Post']: temp.Name,
            },
        });
    }

    getSelectedPostID = (postName) => {
        //console.log('postname: ', postName);
        if (postName) {
            let temp = this.state.posts.find((item) => item.Name == postName);
            return temp && temp.Id;
        }
        else {
            return 0
        }
    }

    onStateChange = (event) => {
        let stateName = this.getStateName(event.target.value);
        this.setState({
            data: {
                ...this.state.data,
                [event.target.name]: stateName,
            },
        });
    }

    onMaritalStatusChange = (event) => {
        let status = event.target.value == 0 ? "Married" : event.target.value == 1 ? "Unmarried" : null;
        this.setState({
            data: {
                ...this.state.data,
                "Marital_Status": status,
            },
        });
    }

    onGenderChange = (event) => {
        let gender = event.target.value == 1 ? "Female" :
            event.target.value == 0 ? "Male" :
                event.target.value == 2 ? "Other" : null
        this.setState({
            data: {
                ...this.state.data,
                "Gender": gender,
            },
        });
    }

    getStateID(stateName) {
        if (stateName) {
            var item = States.find(item => item.Name == stateName);
            return item ? item.Id : -1;
        }
        return -1;
    }

    getStateName(stateId) {
        if (stateId) {
            var item = States.find(item => item.Id == stateId);
            return item ? item.Name : "";
        }
        return "";
    }


    getAllDisableCategories = async () => {
        this.setState({ loading: true });

        try {
            const response = await _StudentService.getAllDisableCategories();

            if (response?.data && Array.isArray(response.data)) {
                this.setState({
                    CategoriesList: response.data, // use directly
                    loading: false,
                });
            } else {
                throw new Error("Invalid or empty data returned from API");
            }
        } catch (error) {
            this.setState({ loading: false });
            console.error("Error fetching disabled categories:", error);
        }
    };

    onCategoryChange = (event) => {
        const selectedId = event.target.value;

        this.setState((prevState) => {
            const selectedCategory = prevState.CategoriesList.find(
                (cat) => cat.Id === selectedId
            );

            return {
                selectedCategory: selectedId,
                data: {
                    ...prevState.data,
                    // Always reset these fields on change
                    IsScribeRequired: false,
                    IsScribeConditionAgreed: false,
                    Scribe_Cert_Path: "",
                    DisabilityCategoryId: selectedId || null,
                    DisabilityCategoryName: selectedCategory?.Name || "N/A",
                },
            };
        });
    };

    uploadScribeImage = async (selectedFile, profileImagePath) => {
        try {
            const body = new FormData();
            body.append('files[]', selectedFile);

            //console.log("Signature Image Body: ", body);

            const response = await _StudentService.uploadScribeImage(body);
            //console.log("Signature Image Response: ", response);
            // debugger
            if (response.data.IsSucess) {
                this.setState((prevState) => ({
                    loading: false,
                    ScribeImagePath: response.data.URL,
                    data: {
                        ...prevState.data,
                        IsScribeConditionAgreed: false,
                        Scribe_Cert_Path: response.data.URL, 
                    },
                }), () => {
                    _notification.showMessage('success', 'Disability Certificate uploaded successfully.');
                });
            }
            else {
                this.setState({
                    loading: false
                }, () => {
                    _notification.showMessage('error', response.data.message);
                })
            }
        } catch (e) {
            // TODO
            console.log('Error: ', e);
        }
    };

    handleMainCheckbox = (event) => {
        const isChecked = event.target.checked;

        this.setState((prevState) => ({
            isSectionEnabled: isChecked,
            // hasInteracted: true, // ✅ mark user has toggled checkbox

            categoryError: "",
            data: {
                ...prevState.data,
                Is_Handicaped: isChecked,
                ...(isChecked === false && {
                    IsScribeRequired: false,
                    IsScribeConditionAgreed: false,
                    Scribe_Cert_Path: "",
                    DisabilityCategoryId: null,
                    DisabilityCategoryName: "N/A",
                }),
            },
        }));
    };

    handleDropdownChange = (value) => {
        this.setState({
            selectedDisability: value,
            dependentCheckboxes: false,
            // Show checkbox for that selected value (set to false initially)
            dependentCheckboxes: {
                ...this.state.dependentCheckboxes,
                [value]: false,
            },
        });
    };



    // Handle checkbox toggle
    handleDependentCheckboxChange = (categoryId) => (event) => {
        const isChecked = event.target.checked;

        this.setState((prevState) => ({
            dependentCheckboxes: {
                ...prevState.dependentCheckboxes,
                [categoryId]: isChecked,
            },

        }));

        this.setState({
            data: {
                ...this.state.data,
                "IsScribeRequired": isChecked,
                ...(isChecked === false && {
                    Scribe_Cert_Path: "",
                    IsScribeConditionAgreed: false,
                }),
            },
        });


    };

    // Handle checkbox selection
    OnConfirmCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        //debugger
        this.setState({
            confirmCheck: isChecked,
            confirmError: '',
            data: {
                ...this.state.data,
                "IsScribeConditionAgreed": isChecked,
            },
        });
    };



   
    render() {

        const { data, selectedCategory, dependentCheckboxes, isSectionEnabled, categoryError, CategoriesList, confirmCheck, setScribeImageImagePath } = this.state;


        const isScribeRequired = dependentCheckboxes[selectedCategory] || false;



        // const isScribeRequired =
        //     data && typeof data.IsScribeRequired === "boolean"
        //         ? data.IsScribeRequired
        //         : (selectedCategory && dependentCheckboxes[selectedCategory]) || false;


        if (this.state.isLoading)
            return <LoadingSpinner />

        return (
            <>
                <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={0} />
                {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim, p-4 unchanged. */}
                <div className="candidate-pinfo ent-container gl-bxbr  analysisWrap p-4 mt-3">
                    <Text k="personalInfo.pageHeading" tag="h4" className="ch-heading4 mb-3" />

                    {/* Phase C.7.4D-R1 (§9 "Applied For" Appears Twice): this Card previously duplicated
                        the read-only Applied For value already shown in the compact identity/
                        application summary card above (NavigationTab_new_one.jsx's .ent-identity-grid,
                        which reads the same data.Applied_Post). Investigated and confirmed (not
                        assumed): the DropdownList here carried a hard-coded isDisabled={true} literal
                        with no conditional path anywhere that ever flips it to false, and its
                        onPostChange handler was consequently unreachable dead code — the post is
                        genuinely selected exactly once, at initial Registration (Registration_new.jsx's
                        own Applied_PostId dropdown, which has no isDisabled prop at all). Removing this
                        section removes no functioning business capability: this.state.data.Applied_Post/
                        Applied_PostId are populated independently by getStudentPersonalData() (used
                        elsewhere in this file, e.g. validate()) regardless of whether this Card renders.
                        Per this phase's own "Preferred UX direction" (§9): retain Applied For in the
                        identity summary (unchanged), remove the redundant, non-interactive duplicate
                        here rather than leave an always-disabled control that reads as a rendering
                        defect. */}

                    <Card header={<Text k="personalInfo.personalInformationHeading" tag="h5" className="ch-heading5" />}>
                        <div className="container-fluid borderb  pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.First_Name ? this.state.data.First_Name : ""}
                                        name="First_Name"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.firstNameLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.firstNameError}
                                        errorMessage={this.state.firstNameError}
                                    />

                                </div>
                                <div className="col-sm-4 middleNameAsteriskAlign">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Middle_Name ? this.state.data.Middle_Name : ""}
                                        name="Middle_Name"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.middleNameLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.middleNameError}
                                        errorMessage={this.state.middleNameError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Last_Name ? this.state.data.Last_Name : ""}
                                        name="Last_Name"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.lastNameLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.lastNameError}
                                        errorMessage={this.state.lastNameError}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Mother, Father Name */}
                        <div className="container-fluid borderb pt-3 pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Mother_Name ? this.state.data.Mother_Name : ""}
                                        name="Mother_Name"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.motherNameLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.motherNameError}
                                        errorMessage={this.state.motherNameError}
                                    />

                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Father_Name ? this.state.data.Father_Name : ""}
                                        name="Father_Name"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.fatherNameLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.fatherNameError}
                                        errorMessage={this.state.fatherNameError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Aadhaar_Number ? this.state.data.Aadhaar_Number : ""}
                                        name="Aadhaar_Number"
                                        heading={<div className='displayInGrid'><Text k="personalInfo.aadhaarNumberLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={false}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Gender, Marital Status */}
                        <div className="container-fluid borderb pt-3 pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-md-4 col-sm-12">
                                    <div className="wrap form-group">
                                        <div>
                                            <label className="card-holder-name">
                                                <div class="displayInGrid">
                                                    <Text k="personalInfo.dateOfBirthLabel" />
                                                </div>
                                                <span class="color-red">*</span>
                                            </label>
                                        </div>
                                        <DatePicker
                                            disabled={true} onChange={this.onDateChange} format="DD-MMM-YYYY" value={this.state.data.Birth_Date ?
                                                moment(this.state.data.Birth_Date == '0001-01-01T00:00:00' ? moment().format('YYYY-MM-DD') : this.state.data.Birth_Date, 'YYYY-MM-DD') : ""}
                                            disabledDate={d => !d || d.isAfter(moment()) || d.isSameOrBefore("1900-01-01")}
                                            className={
                                                ((this.state.dobError) ? "has-error" : "")
                                            } style={{ width: "100%" }} />
                                    </div>


                                    {/* <DatePicker onChange={this.onChange} value={moment(this.state.data.Birth_Date).format("DD/MM/YYYY")}/> */}
                                </div>
                                <div className="col-md-4 col-sm-6 radioBoxTopMargin">

                                    {/* Phase C.7.4D-R5 (§5): briefly tried `ent-inline-radio-field` here (label
                                        inline with its Radio.Group, on one row). Phase C.7.4D-R5.1 (§4) reverted
                                        this — the desired final layout is the label on its own line ABOVE the
                                        radio group (radio options stay inline with each other, unchanged), i.e.
                                        the same stacked structure R1-R4 already had. */}
                                    <div className="wrap form-group">
                                        <div>
                                            <label className="card-holder-name">
                                                <div class="displayInGrid">
                                                    <Text k="personalInfo.genderLabel" />
                                                </div>
                                                <span class="color-red">*</span>
                                            </label>
                                        </div>

                                        <Radio.Group className="d-flex" onChange={this.onGenderChange}
                                            value={this.state.data.Gender == "Female" ? 1 :
                                                this.state.data.Gender == "Male" ? 0 :
                                                    this.state.data.Gender == "Other" ? 2 : null}>
                                            <Radio value={0} className="d-flex">
                                                <label className="card-holder-name mr-2 mb0  radio-label">
                                                    {/* Phase C.7.4D-R3 (§5): the leading {' '} (a literal, rendered
                                                    space character before the option text) was dead/accidental
                                                    whitespace — no second (e.g. bilingual) child exists here to
                                                    justify it — and was one of the two contributors to the
                                                    label sitting further from its radio than intended. Removed;
                                                    the antd default control-to-label spacing is unchanged. */}
                                                <div className='displayInGrid'>
                                                        <Text k="personalInfo.maleLabel" />
                                                    </div>
                                                </label>
                                            </Radio>
                                            <Radio value={1} className="d-flex">
                                                <label className="card-holder-name mr-2 mb0  radio-label">
                                                    {/* Phase C.7.4D-R3 (§5): dead leading space removed, see Male's identical fix above. */}
                                                    <div className='displayInGrid'>
                                                        <Text k="personalInfo.femaleLabel" />
                                                    </div>
                                                </label>

                                            </Radio>
                                            <Radio value={2} className="d-flex">
                                                <label className="card-holder-name mr-2 mb0  radio-label">
                                                    {/* Phase C.7.4D-R3 (§5): dead leading space removed, see Male's identical fix above. */}
                                                    <div className='displayInGrid'>
                                                        <Text k="personalInfo.otherLabel" />
                                                    </div>
                                                </label>
                                            </Radio>
                                        </Radio.Group>
                                        {this.state.genderError && <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.genderError}</label>}
                                    </div>

                                </div>
                                <div className="col-md-4 col-sm-6 radioBoxTopMargin">
                                    <div className="wrap form-group">
                                        <div>
                                            <label className="card-holder-name radio-label">
                                                <div class="displayInGrid">
                                                    <Text k="personalInfo.maritalStatusLabel" />
                                                </div>
                                                <span class="color-red">*</span>
                                            </label>
                                        </div>
                                        <Radio.Group className="d-flex" onChange={this.onMaritalStatusChange}
                                            value={this.state.data.Marital_Status == "Married" ? 0 : this.state.data.Marital_Status == "Unmarried" ? 1 : null}>
                                            <Radio value={0} className="d-flex">
                                                <label className="card-holder-name mr-2 mb0  radio-label">
                                                    {/* Phase C.7.4D-R3 (§5): dead leading space removed, see Male's identical fix above. */}
                                                    <div className='displayInGrid'>
                                                        <Text k="personalInfo.marriedLabel" />
                                                    </div>
                                                </label>
                                            </Radio>
                                            <Radio value={1} className="d-flex">
                                                <label className="card-holder-name mr-2 mb0  radio-label">
                                                    {/* Phase C.7.4D-R3 (§5): dead leading space removed, see Male's identical fix above. */}
                                                    <div className='displayInGrid'>
                                                        <Text k="personalInfo.unmarriedLabel" />
                                                    </div>
                                                </label>

                                            </Radio>
                                        </Radio.Group>
                                        {this.state.maritalStatusError && <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{this.state.maritalStatusError}</label>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Mobile, Phone, Email ID */}
                        <div className="container-fluid pt-3 pr-0 pl-0">
                            <div className="row flex-sm-row">
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Mobile_Number ? this.state.data.Mobile_Number : ""}
                                        name="Mobile_Number"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.mobileNoLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.mobileError}
                                        errorMessage={this.state.mobileError}
                                    />
                                </div>
                                {/* <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Phone_Number ? this.state.data.Phone_Number : ""}
                                        name="Phone_Number"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><div>Phone</div><div>फोन क्रमांक</div></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={false}
                                    // errorState={this.state.mobileError}
                                    // errorMessage={this.state.mobileError}
                                    />

                                </div> */}
                                <div className="col-sm-4 emailIdandMobNoAsteriskAlign">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Email ? this.state.data.Email : ""}
                                        name="Email"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.emailIdLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        disabled
                                        errorState={this.state.emailError}
                                        errorMessage={this.state.emailError}
                                    />
                                </div>

                                {this.state.data.IsDrivingLicenceMandatory &&
                                    <div className="col-sm-4">
                                        <MyInput
                                            type="text"
                                            value={this.state.data.DrivingLicenceNumber ? this.state.data.DrivingLicenceNumber : ""}
                                            name="DrivingLicenceNumber"
                                            onChange={this.onTextChange}
                                            heading={<div className='displayInGrid'><Text k="personalInfo.drivingLicenceLabel" /></div>}
                                            className="w-100"
                                            wrapClass="wrap"
                                            isRequired={true}
                                            errorState={this.state.drivingLicenceError}
                                            errorMessage={this.state.drivingLicenceError}
                                        />
                                    </div>}
                            </div>
                        </div>
                    </Card>

                    <Card header={<Text k="personalInfo.addressDetailsHeading" tag="h5" className="ch-heading5" />}>
                        <div className="container-fluid borderb pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <TextArea
                                        rows={3}
                                        value={this.state.data.Address ? this.state.data.Address : ""}
                                        name="Address"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.addressLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.addressError}
                                        errorMessage={this.state.addressError}
                                    />

                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Village ? this.state.data.Village : ""}
                                        name="Village"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.villageLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        // disabled={this.state.radioButtonValue === 2 ? true : false}
                                        isRequired={true}
                                        errorState={this.state.villageError}
                                        errorMessage={this.state.villageError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Taluka ? this.state.data.Taluka : ""}
                                        name="Taluka"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.talukaLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.talukaError}
                                        errorMessage={this.state.talukaError}
                                    />
                                </div>

                            </div>
                        </div>


                        <div className="container-fluid pt-3 pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.District ? this.state.data.District : ""}
                                        name="District"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.districtLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.districtError}
                                        errorMessage={this.state.districtError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <DropdownList
                                        value={this.getStateID(this.state.data.State)}
                                        name="State"
                                        onChange={this.onStateChange}
                                        placeholder={tr('personalInfo.selectStatePlaceholder')}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.stateLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={States}
                                        errorState={this.state.stateError}
                                        errorMessage={this.state.stateError}
                                    />
                                </div>
                                <div className="col-sm-4">
                                    <MyInput
                                        type="text"
                                        value={this.state.data.Pin_Code ? this.state.data.Pin_Code : ""}
                                        name="Pin_Code"
                                        onChange={this.onTextChange}
                                        heading={<div className='displayInGrid'><Text k="personalInfo.pinCodeLabel" /></div>}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        errorState={this.state.pinError}
                                        errorMessage={this.state.pinError}
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>

                    <Card header={<Text k="personalInfo.pwbdDetailsHeading" tag="h5" className="ch-heading5" />}>
                        <div className="container-fluid pr-0 pl-0">
                            <div className="row flex-sm-row ">
                                <div className="row w-100 m-0">

                                    <div className="mt-3 col-xl-6 col-lg-12">
                                       {/* {JSON.stringify(this.state.data?.Is_Handicaped || false)} */}
                                        <InputCheck
                                            id="Is_Handicaped"
                                            type="checkbox"
                                            label={
                                                <div className='displayInGrid'>
                                                    <Text k="personalInfo.selectDisabilityCategoryCheckboxLabel" />
                                                </div>
                                            }
                                            name="Is_Handicaped"
                                            onChange={this.handleMainCheckbox}
                                            checked={this.state.data?.Is_Handicaped || false}
                                        />
                                    </div>
                                    <div className="row w-100 m-0">
                                        {this.state.data?.Is_Handicaped == true && (
                                            <div
                                                className="col-xl-6 col-lg-12 mt-2 mr-4"
                                            >
                                                <DropdownList
                                                    value={this.state.data.DisabilityCategoryId}
                                                    name="CategoriesList"
                                                    onChange={this.onCategoryChange}
                                                    placeholder={tr('personalInfo.selectCategoryPlaceholder')}
                                                    heading={
                                                        <div className="displayInGrid">
                                                            <Text k="personalInfo.disabilityCategoryLabel" />
                                                        </div>
                                                    }
                                                    className="w-100"
                                                    wrapClass="wrap"
                                                    isRequired={true}
                                                    options={CategoriesList}
                                                    valueField="Id"
                                                    textField="Name"
                                                    errorState={categoryError}
                                                    errorMessage={categoryError}
                                                />
                                            </div>
                                        )}

                                       {this.state.data.DisabilityCategoryId !== null && this.state.data.DisabilityCategoryId !== "" && (
                                            <div className="mt-3 ml-4">
                                                <InputCheck
                                                    id="IsScribeRequired"
                                                    type="checkbox"
                                                    label={
                                                        <div className="displayInGrid">
                                                            <Text k="personalInfo.isScribeRequiredLabel" />
                                                        </div>
                                                    }
                                                    name="IsScribeRequired"
                                                    onChange={this.handleDependentCheckboxChange(selectedCategory)}
                                                    checked={this.state.data.IsScribeRequired}
                                                />
                                            </div>)}
                                    </div>

                                 {this.state.data.DisabilityCategoryId !== null && this.state.data.DisabilityCategoryId !== "" && this.state.data.IsScribeRequired == true && (

                                        <div className="pt-3 pb-2 ml-4">

                                            <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2 candidate-imagesignature-wrap" >
                                                <div className="container-fluid  pr-0 pl-0  borderb">
                                                    <div className="row">
                                                        <div className="col-sm-12 pb-3 EditProflePic">
                                                            <ScribePdfModalViwer />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2 candidate-imagesignature-wrap" >
                                                <Text k="personalInfo.uploadDisabilityCertificateHeading" tag="h5" className="ch-heading5 ml-4 mb-3" />
                                                <div className="col-sm-12 mr-4 pb-3 pt-2 EditSignaturePic">
                                                    <AadhaarAvatar
                                                        isScribe={true}
                                                        srcImage={(this.state.data.Scribe_Cert_Path)}
                                                        setImage={this.uploadScribeImage}
                                                        uploadButtonText={<div className='displayInGrid'><Text k="personalInfo.uploadDisabilityCertificateButton" /></div>}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    {this.state.data.DisabilityCategoryId !== null && this.state.data.DisabilityCategoryId !== "" && this.state.data?.IsScribeRequired == true && this.state.data.Scribe_Cert_Path !== "" && this.state.data.Scribe_Cert_Path !== null && (
                                        <div className="mt-3 ml-2">
                                            <InputCheck
                                                id="IsScribeConditionAgreed"
                                                type="checkbox"
                                                // Phase C.7.4D-R1 (§4): ent-required-asterisk — zero gap after label text.
                                                label={<div className='displayInGrid'><Text k="personalInfo.scribeDeclarationText" /><span className="color-red ent-required-asterisk">*</span></div>}
                                                name="IsScribeConditionAgreed"
                                                onChange={this.OnConfirmCheckboxChange}
                                                checked={this.state.data.IsScribeConditionAgreed}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Card>

                    <div className="row mt-4">

                        <div className="col-12">

                            <div className=" form-action d-flex justify-content-end ">
                                <ButtonComponent
                                    id="btnCancel"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="personalInfo.cancelButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onCancel} />

                                <ButtonComponent
                                    id="btnSubmit"
                                    type="button"
                                    disabled={
                                        (this.state.data.IsScribeRequired == true && this.state.data.IsScribeConditionAgreed !== true)
                                    }
                                    style={{
                                        cursor: (this.state.data.IsScribeRequired == true && this.state.data.IsScribeConditionAgreed !== true)
                                            ? 'not-allowed'
                                            : 'pointer'
                                    }}
                                    value={<div className='displayInGrid'><Text k="personalInfo.saveButton" /></div>}
                                    className="button-global button-primary autoHeight"
                                    onClick={this.updateStudentPersonalData} />
                            </div>
                        </div>
                    </div>

                </div>
                {this.state.isLoading && <LoadingSpinner />}
            </>
        )
    };
}

export default CandidatePersonalInfo_new;